var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.8125L13.0625 5.71875L14 6.65625L6 14.6562L2.28125 10.9375L3.1875 10L6 12.8125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneRegular);
export default __webpack_public_path__ + "static/media/DoneRegular.39dd34594c13dfa00843e4f4396e04eb.svg";
export { ForwardRef as ReactComponent };